// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomPaperBox_wrapper__+2-hB","default":"CustomPaperBox_default__uGhQt","primary":"CustomPaperBox_primary__QIgf4","bold":"CustomPaperBox_bold__K9wmh"};